const PostAuth = (data, cb) => {
  fetch(`${process.env.REACT_APP_API}/admin/api/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Agent-Header": "bticino",
    },
      body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((json) => cb(null, json))
    .catch((err) => cb(err, null));
};

export default PostAuth;
